define('common/views/trial_expiration_popup',['require','exports','module','common/views/modal_view','services/auth/trial','services/auth/info','env','jquery','i18n','ldsh!../templates/trial_expiration_popup'],function (require, exports, module) {
  'use strict';

  var ModalView = require('common/views/modal_view'),
    AuthTrial = require('services/auth/trial'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo(),
    config = require('env'),
    authTrial = new AuthTrial();
  var $ = require('jquery');
  var i18n = require('i18n');

  module.exports = ModalView.extend(
    {
      template: require('ldsh!../templates/trial_expiration_popup'),
      events: {
        'click .js-accept': 'accept',
      },
      helpers: function () {
        return {
          paymentsUrl: config.paymentsUrl,
          companyId: authInfo.getCompanyId(),
        };
      },
      accept: function (e) {
        e.preventDefault();
        e.stopPropagation();
        authTrial.markAsDisplayed();
        this.hide();
      },
      onRender: function () {
        this.$el.i18n();
      },
    },
    {
      show: function () {
        var popup = new module.exports();
        return popup;
      },
    }
  );
});

